/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ ext: NonNullable<unknown> }} Iframe_Remote_Subtitle_Unsupported_Format_ErrorInputs */

const en_iframe_remote_subtitle_unsupported_format_error = /** @type {(inputs: Iframe_Remote_Subtitle_Unsupported_Format_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unsupported subtitle format: ${i?.ext}`)
};

const fr_iframe_remote_subtitle_unsupported_format_error = /** @type {(inputs: Iframe_Remote_Subtitle_Unsupported_Format_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Format de sous-titres non pris en charge : ${i?.ext}`)
};

const de_iframe_remote_subtitle_unsupported_format_error = /** @type {(inputs: Iframe_Remote_Subtitle_Unsupported_Format_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nicht unterstütztes Untertitelformat: ${i?.ext}`)
};

const it_iframe_remote_subtitle_unsupported_format_error = /** @type {(inputs: Iframe_Remote_Subtitle_Unsupported_Format_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Formato sottotitoli non supportato: ${i?.ext}`)
};

const ru_iframe_remote_subtitle_unsupported_format_error = /** @type {(inputs: Iframe_Remote_Subtitle_Unsupported_Format_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Неподдерживаемый формат субтитров: ${i?.ext}`)
};

const es_iframe_remote_subtitle_unsupported_format_error = /** @type {(inputs: Iframe_Remote_Subtitle_Unsupported_Format_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Formato de subtítulos no compatible: ${i?.ext}`)
};

const zh_cn2_iframe_remote_subtitle_unsupported_format_error = /** @type {(inputs: Iframe_Remote_Subtitle_Unsupported_Format_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`不支持的字幕格式：${i?.ext}`)
};

const ja_iframe_remote_subtitle_unsupported_format_error = /** @type {(inputs: Iframe_Remote_Subtitle_Unsupported_Format_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`サポートされていない字幕形式: ${i?.ext}`)
};

const hi_iframe_remote_subtitle_unsupported_format_error = /** @type {(inputs: Iframe_Remote_Subtitle_Unsupported_Format_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`असमर्थित उपशीर्षक प्रारूप: ${i?.ext}`)
};

const pt_pt2_iframe_remote_subtitle_unsupported_format_error = /** @type {(inputs: Iframe_Remote_Subtitle_Unsupported_Format_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Formato de legenda não suportado: ${i?.ext}`)
};

/**
* | output |
* | --- |
* | "Unsupported subtitle format: {ext}" |
*
* @param {Iframe_Remote_Subtitle_Unsupported_Format_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_subtitle_unsupported_format_error = /** @type {((inputs: Iframe_Remote_Subtitle_Unsupported_Format_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Subtitle_Unsupported_Format_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_subtitle_unsupported_format_error(inputs)
	if (locale === "de") return de_iframe_remote_subtitle_unsupported_format_error(inputs)
	if (locale === "it") return it_iframe_remote_subtitle_unsupported_format_error(inputs)
	if (locale === "ru") return ru_iframe_remote_subtitle_unsupported_format_error(inputs)
	if (locale === "es") return es_iframe_remote_subtitle_unsupported_format_error(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_subtitle_unsupported_format_error(inputs)
	if (locale === "ja") return ja_iframe_remote_subtitle_unsupported_format_error(inputs)
	if (locale === "hi") return hi_iframe_remote_subtitle_unsupported_format_error(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_subtitle_unsupported_format_error(inputs)
	return en_iframe_remote_subtitle_unsupported_format_error(inputs)
});